<template>
  <b-modal
    :visible="visible"
    @close="$emit('close')"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    size="lg"
  >
    <span slot="modal-title" class="">Value not selected</span>
    <b-row>
      <b-col cols="12" class="text-center  my-2">
        <slot name="modal-msg">
          <span>{{ sliderNotAnsweredModalMsg }}</span>
        </slot>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="w-100 d-flex justify-content-around flex-column flex-lg-row"
    >
      <b-button
        variant="v2_primary"
        class="mb-2 mb-lg-0"
        @click="$emit('close')"
      >
        Return to Question
      </b-button>
      <b-button
        variant="v2_primary"
        class="mb-2 mb-lg-0"
        :disabled="resetMinDisabled"
        @click="
          $emit(
            'reset-to-min',
            visibleVariables.map((v) => v.id)
          )
        "
      >
        Accept Defaults
      </b-button>
      <b-button
        variant="v2_primary"
        class="mb-2 mb-lg-0"
        @click="$emit('answer-later')"
      >
        Answer Question Later
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { QUESTION_TYPES } from '@/store';
import { isVariableMatchVisibilityCondition } from '@/helpers/questionnaireHelper';

export default {
  name: 'SliderNotAnsweredModal',
  props: {
    question: Object,
    visible: Boolean,
    variables: Array,
    resetMinDisabled: Boolean,
  },
  model: {
    prop: 'visible',
    event: 'close',
  },
  computed: {
    visibleVariables: function () {
      return this.question.variables.filter(
        (variable) =>
          !variable.delete_me &&
          isVariableMatchVisibilityCondition(variable, this.variables)
      );
    },
    sliderNotAnsweredModalMsg: function () {
      if (this.question.type !== QUESTION_TYPES.SLIDER) {
        return '';
      }
      let minValues = this.visibleVariables.map(({ min }) => (min ? min : 0));
      return `You have not selected a value for this question. Would you like to go
          back and enter a value, accept the default ${
            minValues.length > 1 ? 'values' : 'value'
          } (${minValues.join(', ')}), or answer this
          question later?`;
    },
  },
};
</script>

<style scoped></style>
